import request from '@/utils/request'

export function userInfor(data) {
  return request({
    url: '/user/info',
    method: 'get',
    params: data,
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  })
}

export function shoppingCartList() {
  return request({
    url: '/shoppingCarts',
    method: 'get',
  })
}

export function getNavs(data) {
  return request({
    url: '/common/navs',
    method: 'get',
    params: data,
  })
}

export function commonInfo() {
  return request({
    url: 'bkc/system/commonInfo',
    method: 'get',
  })
}
